import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Search, X } from "lucide-react";

export const SearchBar = ({ id = "search", className = "", onSubmit }) => {
  const [sp] = useSearchParams();
  const [q, setQ] = useState(sp.get("q") || "");
  const navigate = useNavigate();

  useEffect(() => { setQ(sp.get("q") || ""); }, [sp]);

  const go = (e) => {
    e.preventDefault();
    const t = q.trim();
    navigate(t ? `/browse?q=${encodeURIComponent(t)}` : "/browse");
    onSubmit?.();
  };

  return (
    <form onSubmit={go} role="search" data-testid={`${id}-form`} className={`relative flex items-center ${className}`}>
      <Search size={14} strokeWidth={1.8} className="absolute left-3 text-gold pointer-events-none" />
      <input
        data-testid={`${id}-input`} value={q} onChange={(e) => setQ(e.target.value)}
        placeholder="Search stones · Round VS1, PGJ-S012, 1.70 mm…"
        aria-label="Search lab grown diamonds"
        className="h-10 w-full bg-[#121212] border border-gold/35 pl-9 pr-9 text-xs tracking-wide text-ivory placeholder:text-ivory/35 outline-none focus:border-saffron focus:shadow-[0_0_0_1px_#F5CB5C] transition-[border-color,box-shadow]"
      />
      {q && (
        <button type="button" data-testid={`${id}-clear`} onClick={() => { setQ(""); navigate("/browse"); }} aria-label="Clear search" className="absolute right-2 text-ivory/50 hover:text-saffron">
          <X size={14} />
        </button>
      )}
    </form>
  );
};
